export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "eventTypes",
  "eventTypesHeavy",
  "attributes",
  "dsync",
  "features",
  "feedback",
  "holidays",
  "featureOptIn",
  "i18n",
  "insights",
  "pbac",
  "me",
  "ooo",
  "organizations",
  "routingForms",
  "teams",
  "unifiedCalendar",
  "workflows",
  "payments",
  "platformOauthClients",
  "public",
  "timezones",
  "slots",
  "sso",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "googleWorkspace",
  "oAuth",
  "delegationCredential",
  "credits",
  "filterSegments",
  "phoneNumber",
] as const;
